// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { successResponseSchema } from '@/api/schemas';

/**
 * Deletes a cost using the new cost endpoint.
 * This is for normal costs, not time costs.
 *
 * @param costKey - The key of the cost to delete
 */
export async function deleteCost(costKey: string) {
  const url = `/v1/cost/${costKey}`;
  const response = await api.delete(url);

  return parseResponse(successResponseSchema, response.data, {
    schemaName: 'DeleteCost',
    endpoint: url,
  });
}
